/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{z as e,A as r}from"./SpatialReference.js";class t extends e{getOperatorType(){return 4}execute(e,t,a,s){return!r(e,t,a,4,s)}}export{t as O};
